import styled from "styled-components";

export const MainLayout = styled.div`
    padding: 1rem 5rem;
    @media screen and (max-width: 571px){
        padding: 1.5rem;
    }
`;

export const InnerLayout = styled.div`
    padding: 4rem 0;
`;